import { useState, useCallback } from "react";
import dateArray from "./dates.json";

const allTags = [...new Set(dateArray.flatMap((date) => date.Tags))].sort();

export default function App() {
  const [tagFilter, setTagFilter] = useState([]);
  const [currentDate, setCurrentDate] = useState(dateArray[0]);
  const [visible, setVisible] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);

  function toggleTag(tag) {
    setTagFilter((prevTags) =>
      prevTags.includes(tag)
        ? prevTags.filter((t) => t !== tag)
        : [...prevTags, tag],
    );
  }

  const getNextDate = useCallback((tagList) => {
    setVisible(false);
    setTimeout(() => {
      let filteredDates = dateArray;
      if (tagList.length > 0) {
        filteredDates = dateArray.filter((date) =>
          tagList.every((tag) => date.Tags.includes(tag)),
        );
      }

      //No dates found, show a message instead of a date
      if (filteredDates.length === 0) {
        const nextDate = {
          Title: "No Dates Found",
          Description: "No dates match the selected tags. Please try again.",
          Tags: [],
          Budget: "",
        };
        setCurrentDate(nextDate);
        setVisible(true);
        return;
      }

      const nextDate =
        filteredDates[Math.floor(Math.random() * filteredDates.length)];
      setCurrentDate(nextDate);
      setVisible(true);
    }, 300);
  }, []);

  return (
    <div className="app-layout">
      {menuOpen && (
        <div className="sidebar-overlay" onClick={() => setMenuOpen(false)} />
      )}
      <aside className={`sidebar${menuOpen ? " sidebar--open" : ""}`}>
        <div className="sidebar-header">
          <h2 className="sidebar-title">Filter by Tag</h2>
          <button
            className="sidebar-close-btn"
            onClick={() => setMenuOpen(false)}
          >
            ✕
          </button>
        </div>
        <DateTagList
          allTags={allTags}
          activeTags={tagFilter}
          toggleTag={toggleTag}
        />
        {tagFilter.length > 0 && (
          <button
            className="clear-filters-button"
            onClick={() => setTagFilter([])}
          >
            Clear Filters
          </button>
        )}
      </aside>
      <main className="main-content">
        <div className="mobile-header">
          <button className="hamburger-btn" onClick={() => setMenuOpen(true)}>
            ☰
          </button>
          {tagFilter.length > 0 && (
            <span className="mobile-filter-badge">
              {tagFilter.length} filter{tagFilter.length !== 1 ? "s" : ""}{" "}
              active
            </span>
          )}
        </div>
        <h1 className="page-title">{dateArray.length} Dates ♥</h1>
        <DateCard
          date={currentDate}
          activeTags={tagFilter}
          toggleTag={toggleTag}
          visible={visible}
        />
        <button
          className="next-date-button"
          onClick={() => getNextDate(tagFilter)}
        >
          ♥ New Date
        </button>
      </main>
    </div>
  );
}

function DateCard({ date, activeTags, toggleTag, visible }) {
  return (
    <div className={`date-card${visible ? "" : " date-card--hidden"}`}>
      <h2 className="date-title">{date.Title}</h2>
      <p className="date-description">{date.Description}</p>
      <div className="date-tags">
        {date.Tags.map((tag, index) => (
          <DateTag
            key={index}
            tag={tag}
            active={activeTags.includes(tag)}
            handleTagClick={() => toggleTag(tag)}
          />
        ))}
      </div>
      <p className="date-budget">
        <span className="budget-label">Budget:</span> {date.Budget}
      </p>
    </div>
  );
}

function DateTag({ tag, active, handleTagClick }) {
  return (
    <span
      className={`date-tag${active ? " date-tag--active" : ""}`}
      onClick={() => handleTagClick(tag)}
    >
      {tag}
    </span>
  );
}

function DateTagList({ allTags, activeTags, toggleTag }) {
  return (
    <div className="tag-filter-list">
      {allTags.map((tag, index) => (
        <button
          key={index}
          className={`tag-filter-item${activeTags.includes(tag) ? " tag-filter-item--active" : ""}`}
          onClick={() => toggleTag(tag)}
        >
          {activeTags.includes(tag) ? "✓ " : ""}
          {tag}
        </button>
      ))}
    </div>
  );
}
